import { Box, Container, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { sectionColors } from "../app/theme";
import { useContent } from "../app/ContentContext";

const infoCardSx = {
  flex: { xs: "none", md: 1 },
  width: { xs: "100%", md: "auto" },
  maxWidth: 280,
  p: 3,
  borderRadius: 4,
  backgroundColor: "common.white",
  boxShadow: "0 2px 16px rgba(7, 73, 116, 0.08)",
};

function Contact() {
  const { contactPage } = useContent();
  return (
    <Box
      id="contact-section"
      sx={{
        scrollMarginTop: "80px",
        py: { xs: 5, md: 7 },
        backgroundColor: sectionColors.contactBackground,
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
          {contactPage.title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "center", md: "stretch" },
            justifyContent: "center",
            gap: 3,
            mb: 5,
          }}
        >
          <Box sx={infoCardSx}>
            <AccessTimeIcon fontSize="large" color="primary" />
            <Typography variant="h6" gutterBottom sx={{ mt: 1 }}>
              {contactPage.openingHoursLabel}
            </Typography>
            <Typography color="text.secondary">
              {contactPage.openingHours}
            </Typography>
            <Typography color="text.secondary">
              {contactPage.scheduleNote}
            </Typography>
          </Box>
          <Box sx={infoCardSx}>
            <PhoneIcon fontSize="large" color="primary" />
            <Typography variant="h6" gutterBottom sx={{ mt: 1 }}>
              {contactPage.phoneHoursLabel}
            </Typography>
            <Typography color="text.secondary">
              {contactPage.phoneHours}
            </Typography>
            <Typography>
              <a
                href={contactPage.phoneHref}
                style={{ color: "inherit", fontWeight: 600 }}
              >
                {contactPage.phoneDisplay}
              </a>
            </Typography>
            <Typography color="text.secondary">
              {contactPage.scheduleNote}
            </Typography>
          </Box>
          <Box sx={infoCardSx}>
            <MailOutlineIcon fontSize="large" color="primary" />
            <Typography variant="h6" gutterBottom sx={{ mt: 1 }}>
              {contactPage.emailLabel}
            </Typography>
            <Typography>
              <a
                href={`mailto:${contactPage.email}`}
                style={{ color: "inherit", fontWeight: 600 }}
              >
                {contactPage.email}
              </a>
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 3,
          }}
        >
          <Box
            component="iframe"
            title="Stavanger ØNH kart"
            src={contactPage.mapEmbedUrl}
            sx={{
              border: 0,
              borderRadius: 3,
              height: { xs: "260px", md: "360px" },
              width: { xs: "100%", sm: "45%", md: "38%" },
              boxShadow: "0 2px 16px rgba(7, 73, 116, 0.08)",
            }}
          />
          <Box
            component="img"
            title="Stavanger ØNH kart"
            src={contactPage.entrancePhoto}
            sx={{
              border: 0,
              borderRadius: 3,
              height: { xs: "260px", md: "360px" },
              width: { xs: "100%", sm: "45%", md: "38%" },
              objectFit: "cover",
              boxShadow: "0 2px 16px rgba(7, 73, 116, 0.08)",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}

export default Contact;
